<div class="fui-layout-container">
  <fui-layout-header [breadcrumbs]="breadcrumbs" headingText="fui-header.learn" [description]="'newdash.fender_learn_description'">
    <div class="d-flex align-items-center justify-content-between m-t-30 flex-wrap">
      <div class="fui-nav-pills">
        <ul>
          <!-- <li>
          <button [class.active]="displayedSection == 'browse'" (click)="switchSection('browse')" (keyup.enter)="switchSection('browse')" (keyup.space)="switchSection('browse')">
            {{ "education.browse" | translate }}
          </button>
        </li> -->
          <li>
            <button
              [disabled]="!educationData"
              [class.active]="displayedSection == 'videos'"
              (click)="switchSection('videos')"
              (keyup.enter)="switchSection('videos')"
              (keyup.space)="switchSection('videos')"
            >
              <fa-icon icon="video" class="m-r-5"></fa-icon>
              {{ "education.videos" | translate }}
            </button>
          </li>
          <li>
            <button
              [disabled]="!educationData"
              [class.active]="displayedSection == 'lessons'"
              (click)="switchSection('lessons')"
              (keyup.enter)="switchSection('lessons')"
              (keyup.space)="switchSection('lessons')"
            >
              <fa-icon icon="graduation-cap" class="m-r-5"></fa-icon>
              {{ "education.lessons" | translate }}
            </button>
          </li>
          <!-- <li *ngIf="appService.videoContentType.presonus">
        <button [disabled]="!educationData" [class.active]="displayedSection == 'courses'" (click)="switchSection('courses')" (keyup.enter)="switchSection('courses')" (keyup.space)="switchSection('courses')">
          {{ "education.courses" | translate }}
        </button>
      </li> -->
          <li>
            <button
              [disabled]="!educationData"
              [class.active]="displayedSection == 'mylist'"
              (click)="switchSection('mylist')"
              (keyup.enter)="switchSection('mylist')"
              (keyup.space)="switchSection('mylist')"
            >
              <fa-icon icon="book" class="m-r-5"></fa-icon>
              {{ "education.my_library" | translate }}
            </button>
          </li>
          <li>
            <button
              [disabled]="!educationData"
              [class.active]="displayedVideoGroup?.title == 'All Videos'"
              (click)="showAllVideos(true)"
              (keyup.enter)="showAllVideos(true)"
              (keyup.space)="showAllVideos(true)"
            >
              <fa-icon icon="search" class="m-r-5"></fa-icon>
              {{ "my_gear.search" | translate }}
            </button>
          </li>
        </ul>
      </div>
      <div class="fui-content-filter-content-type">
        <div class="d-flex">
          <div class="d-flex align-items-center m-r-10">
            <myp-switch [small]="true" (toggle)="toggleVideoContentType('fender')" [active]="appService.videoContentType.fender" activeTrackColor="#ed1c2e"></myp-switch>
            <myp-svg [id]="'fender-headstock'" [class]="'svg-red'" width="20" height="20"></myp-svg>
            {{ "education.learn_to_play" | translate }}
          </div>
          <div class="d-flex align-items-center">
            <myp-switch [small]="true" (toggle)="toggleVideoContentType('presonus')" [active]="appService.videoContentType.presonus"></myp-switch>
            <myp-svg [id]="'microphone'" [class]="'svg-blue'" width="20" height="20"></myp-svg>
            {{ "education.learn_to_record" | translate }}
          </div>
        </div>
      </div>
    </div>
  </fui-layout-header>
  @if (displayedVideoGroup) {
    <hr />
  }
  @if (displayedVideoGroup) {
    <div class="fui-layout-pad-content">
      <fui-content-filter
        #fuiContentFilter
        [widerSearch]="true"
        [showViewOption]="false"
        [activeQuery]="filters.query"
        [filters]="filters"
        (refineClicked)="showFilterOptions = !showFilterOptions"
        [resultsCount]="filterableVideoGroup?.totalVideos || 0"
        (clearQuery)="filters.query = ''; filterableVideoGroup.filters.query = ''; filterableVideoGroup.filter()"
        [showSortOptionsToggle]="displayedFolder ? true : false"
        (clearFilter)="filterableVideoGroup.clearFilter()"
        [searchPlaceholder]="displayedFolder ? 'sphere.search' : 'general.search_all_videos'"
        (queryChanged)="filterableVideoGroup.filter($event)"
        (sortChanged)="filterableVideoGroup.filter()"
        (showMobileFiltersClicked)="filterableVideoGroup.showMobileFilters()"
        [showSidebarToggle]="!!displayedVideoGroup"
      ></fui-content-filter>
    </div>
  }
  @if (displayedVideoGroup) {
    <hr />
  }
  <div class="fui-layout-edge-content refine-content">
    @if (displayedVideoGroup) {
      <fui-filterable-video-group
        #filterableVideoGroup
        [videos]="displayedVideoGroup.videos"
        [educationData]="educationData"
        [title]="displayedVideoGroup?.title"
        [description]="displayedVideoGroup?.description"
        [ignoreBrand]="displayedVideoGroup?.ignoreBrand"
        [showFilterOptions]="showFilterOptions"
        (hideFiltersClicked)="fuiContentFilter.refine()"
        (goBackClicked)="goBack()"
      ></fui-filterable-video-group>
    }

    @if (!displayedVideoGroup) {
      @if (displayedSection == "videos") {
        <section class="section-browse">
          @if (featuredVideoId) {
            <div class="fui-featured-video" #featuredVideoContainer>
              <div class="fui-featured-video-media" aria-hidden="true">
                @if (featuredVideoEmbedUrl) {
                  <iframe
                    #featuredVideoIframe
                    class="fui-featured-video-iframe"
                    [src]="featuredVideoEmbedUrl"
                    title="Featured video"
                    frameborder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                }
                <!-- Layer your hero UI inside this overlay container -->
                <div class="fui-featured-video-overlay">
                  <div class="fui-featured-video-overlay-content">
                    <div class="fui-layout-container">
                      <div class="fui-layout-pad-content">
                        @if (!featuredVideo) {
                          <myp-skeleton-loader type="line" width="20%" height="10px" extraContainerClass="m-b-20"></myp-skeleton-loader>
                          <myp-skeleton-loader type="line" width="70%" height="40px" extraContainerClass="m-b-50"></myp-skeleton-loader>
                          <myp-skeleton-loader type="line" width="90%" height="20px" extraContainerClass="m-b-10"></myp-skeleton-loader>
                          <myp-skeleton-loader type="line" width="95%" height="20px" extraContainerClass="m-b-10"></myp-skeleton-loader>
                          <myp-skeleton-loader type="line" width="40%" height="20px" extraContainerClass="m-b-10"></myp-skeleton-loader>
                        }
                        @if (featuredVideo) {
                          <span class="fui-heading-font t-16">FEATURED VIDEO</span>
                          <h2 class="fui-heading-font">{{ featuredVideo.title }}</h2>
                          @if (featuredVideo.snippet) {
                            <span>{{ featuredVideo.snippet }}</span>
                          }
                          <div class="d-flex align-items-center m-t-20">
                            <button class="btn btn-primary" (click)="appService.showVideo(featuredVideoId)">Watch Now</button>
                            <button class="btn btn-blank m-l-10" (click)="toggleMuteFeaturedVideo()"><fa-icon [icon]="featuredVideoMuted ? 'volume-mute' : 'volume-up'"></fa-icon></button>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="m-y-30">
            @if (!educationData) {
              <div class="fui-layout-pad-content">
                <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
                  @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track item) {
                    <li style="border-radius: 20px; overflow: hidden">
                      <myp-skeleton-loader type="learn-video" class="grid-container wider pad-10"></myp-skeleton-loader>
                    </li>
                  }
                </ul>
              </div>
            }
            @for (folder of displayedFolders; track folder) {
              <div>
                <fui-video-rail [videos]="folder.videos" [title]="folder.title" [description]="folder.description" (showMoreVideos)="selectFolder(folder)"></fui-video-rail>
              </div>
            }
          </div>
        </section>
      }
      @if (displayedSection == "browse") {
        <section class="section-browse">
          @if (appService.videoContentType.fender) {
            <div class="fui-layout-pad-content">
              <div class="d-flex m-y-50">
                <img
                  src="https://images.ctfassets.net/r1mvpfown1y6/5yjE5J0uakdsW3mwcX2vj3/028776befa1f42f7b94fbf6f882c6c26/Welcome_Native.png?w=275"
                  style="max-width: 175px; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1); margin-right: 40px"
                />
                <div style="max-width: 700px">
                  <myp-svg id="fender-play-logo" width="300" height="90"></myp-svg>
                  <fui-heading level="2" fontSize="f9" [text]="'education.fender_play_tagline' | translate"></fui-heading>
                  <br />
                  {{ "education.fender_play_description" | translate }}
                  <br />
                  <a class="btn btn-primary m-t-40" href="https://play.fender.com" target="_blank">{{ "education.get_started" | translate }}</a>
                  <button class="btn btn-blank m-t-40 m-l-10" (click)="appService.showVideo(env.fenderPlayVideoIntroId)">{{ "education.see_how_it_works" | translate }}</button>
                </div>
              </div>
            </div>
          }
          @if (playFolder?.videos?.length && appService.videoContentType.fender) {
            <div class="fui-layout-pad-content m-t-30">
              <fui-heading level="2" fontSize="f7" [text]="'education.browse_free_fender_play_content' | translate"></fui-heading>
              {{ "education.fender_play_subscription_taste" | translate }}
            </div>
            <div class="fui-layout-edge-content">
              <ul class="learn-list-horizontal-scroll video-grid" preventHorizontalNav>
                @for (item of playFolder.videos; track item) {
                  @if (contentService.videosById[item.id]) {
                    <li>
                      <myp-video-grid-item [showKeepWatchingActions]="true" [showLibraryActions]="false" [video]="contentService.videosById[item.id]"></myp-video-grid-item>
                    </li>
                  }
                }
              </ul>
            </div>
            <hr class="m-y-50" />
          }
          @if (appService.videoContentType.presonus) {
            <div class="fui-layout-pad-content">
              <div class="m-b-30">
                <myp-svg id="fender-studio-logo" width="200" height="60"></myp-svg>
                <div>{{ "education.fender_studio_description" | translate }}</div>
              </div>

              <div class="d-flex align-items-center justify-content-between m-t-20 m-b-10">
                <fui-heading level="3" fontSize="f6" [text]="'education.featured_courses' | translate"></fui-heading>
                <span class="section-header-link" (click)="switchSection('courses')">{{ "education.view_all" | translate }}</span>
              </div>
              @if (!contentService.courses?.length) {
                <myp-skeleton-loader type="carousel" extraContainerClass="m-y-20"></myp-skeleton-loader>
              }
              @if (contentService.courses?.length) {
                <div class="featured-carousel" [style]="'background-image: url(' + contentService.courses[selectedCourseIndex].image + ');'">
                  <div class="text-center p-10 dark-trans-bg border-radius10 m-x-30 c-white m-b-20">
                    <fui-heading level="4" textAlign="center" color="white" [text]="contentService.courses[selectedCourseIndex].title"></fui-heading>
                    <span class="brandfont-bold">{{ contentService.courses[selectedCourseIndex].lessons?.length }} Lessons</span>
                    &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                    <span class="brandfont-bold">{{ contentService.courses[selectedCourseIndex].totalVideos }} Videos</span>
                    &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                    <span class="brandfont-bold">{{ helperService.hhmmss(contentService.courses[selectedCourseIndex].runtime, true) }}</span>
                    <div class="m-x-30 m-t-10">{{ contentService.courses[selectedCourseIndex].snippet }}</div>
                    <span class="btn btn-primary m-t-20" [routerLink]="['/learn/course/', contentService.courses[selectedCourseIndex].id]">View Course</span>
                  </div>
                </div>
              }
              <div class="m-t-10 d-flex justify-content-center">
                @for (item of contentService.courses; track item; let i = $index) {
                  <span (click)="selectedCourseIndex = i" class="carousel-dot" [class.selected]="selectedCourseIndex == i"></span>
                }
              </div>
              <div class="d-flex align-items-center justify-content-between m-t-20">
                <fui-heading level="3" fontSize="f6" [text]="'education.featured_lessons' | translate"></fui-heading>
                <span class="section-header-link" (click)="switchSection('lessons')">{{ "education.view_all" | translate }}</span>
              </div>
              @if (!featuredLessons?.length) {
                <myp-skeleton-loader extraContainerClass="m-y-20" number="5" type="list-item-large"></myp-skeleton-loader>
              }
              <ul class="list-group">
                @for (lesson of featuredLessons || []; track lesson) {
                  <li class="list-group-item bg-transparent border-0 p-0">
                    <myp-learn-list-item [showAddToList]="true" [item]="lesson"></myp-learn-list-item>
                  </li>
                }
              </ul>
            </div>
          }
          @if (contentService.userLearnData?.watched_videos?.length) {
            <div class="fui-layout-pad-content m-y-30">
              <fui-heading level="2" fontSize="f7" [text]="'education.keep_watching' | translate"></fui-heading>
              {{ "education.keep_watching_description" | translate }}
            </div>
            <div class="fui-layout-edge-content">
              <ul class="learn-list-horizontal-scroll video-grid" preventHorizontalNav>
                @if (!displayedVideos?.length) {
                  @for (item of [1, 2, 3]; track item) {
                    <li>
                      <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                    </li>
                  }
                }
                @for (item of contentService.userLearnData.watched_videos | keyvalue; track item) {
                  @if (contentService.videosById[item.value.video_id]) {
                    <li>
                      <myp-video-grid-item [showKeepWatchingActions]="true" [showLibraryActions]="false" [video]="contentService.videosById[item.value.video_id]"></myp-video-grid-item>
                    </li>
                  }
                }
              </ul>
            </div>
          }
          @if (contentService.userLearnData?.saved_videos?.length) {
            <div class="fui-layout-pad-content m-y-30">
              <fui-heading level="2" fontSize="f7" [text]="'education.my_saved_videos' | translate"></fui-heading>
              {{ "education.my_saved_videos_description" | translate }}
            </div>
            <div class="fui-layout-edge-content">
              <ul class="learn-list-horizontal-scroll video-grid" preventHorizontalNav>
                @if (!displayedVideos?.length) {
                  @for (item of [1, 2, 3, 4]; track item) {
                    <li>
                      <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                    </li>
                  }
                }
                @for (item of contentService.userLearnData.saved_videos | keyvalue; track item) {
                  <li>
                    <myp-video-grid-item [video]="contentService.videosById[item.value.video_id]"></myp-video-grid-item>
                  </li>
                }
              </ul>
            </div>
          }
        </section>
      }
      @if (displayedSection == "lessons") {
        <div class="fui-header-hero sm blur" style="background-image: url(&quot;./assets/images/hero/lesson-hero.jpg&quot;)">
          <div>
            <fui-heading level="2" fontSize="f11" textAlign="center" [text]="'education.lessons' | translate"></fui-heading>
            <span class="text-center">
              {{ "education.fender_studio_lessons_description" | translate }}
            </span>
          </div>
        </div>
        <section class="section-lesson">
          @if (!educationData?.lessons?.length) {
            <div class="fui-layout-pad-content">
              <myp-skeleton-loader extraContainerClass="m-y-20" number="9" type="list-item-large"></myp-skeleton-loader>
            </div>
          }
          @if (educationData?.lessons?.length) {
            <div class="m-t-100">
              <div class="fui-layout-edge-content">
                @for (lesson of displayedLessons; track lesson) {
                  <fui-video-rail [lesson]="lesson" [videos]="lesson.videos" [title]="lesson.title" [description]="lesson.description" (showMoreVideos)="viewLesson(lesson)"></fui-video-rail>
                }
              </div>
            </div>
          }
        </section>
      }
      @if (displayedSection == "courses") {
        <section class="section-course fui-layout-pad-content">
          @if (!educationData?.courses?.length) {
            <myp-skeleton-loader extraContainerClass="m-y-20" number="2" type="list-item-large"></myp-skeleton-loader>
          }
          @if (appService.videoContentType.presonus && educationData?.courses?.length) {
            <div class="m-t-30">
              <div class="m-b-30">
                <myp-svg id="fender-studio-logo" width="200" height="60"></myp-svg>
                <div>{{ "education.fender_studio_courses_description" | translate }}</div>
              </div>
              <ul class="list-group">
                @for (course of educationData?.courses || []; track course) {
                  @if (
                    (appService.videoContentType.fender && (course.brand == "fender" || course.brand == "both")) ||
                    (appService.videoContentType.presonus && (course.brand == "presonus" || course.brand == "both")) ||
                    (!appService.videoContentType.fender && !appService.videoContentType.presonus)
                  ) {
                    <li class="list-group-item bg-transparent border-0 p-0">
                      <myp-learn-list-item [showAddToList]="true" [item]="course"></myp-learn-list-item>
                    </li>
                  }
                }
              </ul>
            </div>
          }
        </section>
      }
      @if (displayedSection == "mylist") {
        <div class="d-block">
          @if (!educationData) {
            <div class="fui-layout-pad-content">
              <myp-skeleton-loader extraContainerClass="m-y-20" number="5" type="list-item-large"></myp-skeleton-loader>
            </div>
          }
          @if (
            educationData &&
            !(contentService.userLearnData.saved_courses | keyvalue)?.length &&
            !(contentService.userLearnData.saved_lessons | keyvalue)?.length &&
            !(contentService.userLearnData.saved_videos | keyvalue)?.length &&
            !(contentService.userLearnData.watched_videos | keyvalue)?.length
          ) {
            <div class="fui-layout-pad-content m-t-50">
              <div>
                <fui-heading level="2" fontSize="f7" [text]="'education.my_library' | translate"></fui-heading>
                <span>
                  {{ "education.my_library_empty_message" | translate }}
                </span>
              </div>
            </div>
          }
          @if ((contentService.userLearnData.saved_courses | keyvalue)?.length) {
            <section class="m-t-50 section-lesson fui-layout-pad-content">
              <fui-heading level="2" fontSize="f7" [text]="'education.my_courses' | translate"></fui-heading>
              <ul class="list-group">
                @for (item of contentService.userLearnData.saved_courses | keyvalue; track item) {
                  @if (contentService.courseMap[item.value.learn_group_id]) {
                    <li class="list-group-item bg-transparent border-0 p-0">
                      <myp-learn-list-item [item]="contentService.courseMap[item.value.learn_group_id]"></myp-learn-list-item>
                    </li>
                  }
                }
              </ul>
            </section>
          }
          @if (contentService.myWatchedVideos?.length) {
            <section class="m-t-50 section-lesson">
              <fui-video-rail
                [videos]="contentService.myWatchedVideos"
                (showMoreVideos)="showMoreVideos(contentService.myWatchedVideos, 'education.keep_watching', undefined, true)"
                [title]="'education.keep_watching' | translate"
              ></fui-video-rail>
            </section>
          }
          @if (contentService.mySavedVideos?.length) {
            <section class="m-b-50 section-lesson">
              <fui-video-rail
                [videos]="contentService.mySavedVideos"
                (showMoreVideos)="showMoreVideos(contentService.mySavedVideos, 'education.my_saved_videos', undefined, true)"
                [title]="'education.my_saved_videos' | translate"
              ></fui-video-rail>
            </section>
          }
          @if ((contentService.userLearnData.saved_lessons | keyvalue)?.length) {
            <section class="m-b-50 section-lesson">
              <div class="fui-layout-pad-content">
                <fui-heading level="2" fontSize="f9" [text]="'education.my_lessons' | translate"></fui-heading>
              </div>
              <div class="fui-layout-edge-content">
                @for (item of contentService.userLearnData.saved_lessons | keyvalue; track item) {
                  @if (contentService.lessonMap[item.value.learn_group_id]) {
                    <fui-video-rail
                      [lesson]="contentService.lessonMap[item.value.learn_group_id]"
                      [videos]="contentService.lessonMap[item.value.learn_group_id].videos"
                      [title]="contentService.lessonMap[item.value.learn_group_id].title"
                      [description]="contentService.lessonMap[item.value.learn_group_id].description"
                      (showMoreVideos)="viewLesson(contentService.lessonMap[item.value.learn_group_id])"
                    ></fui-video-rail>
                  }
                }
              </div>
            </section>
          }
        </div>
      }
    }
  </div>

  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>
